var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-data-table', _vm._b({
    ref: "data-table",
    attrs: {
      "disable-sort": "",
      "disable-pagination": "",
      "hide-default-footer": "",
      "items-per-page": -1,
      "mobile-breakpoint": "1080"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function (props) {
        return [_vm.$refs['data-table'] ? _c('draggable', {
          attrs: {
            "tag": "tbody",
            "list": props.items,
            "sort": !_vm.loading || _vm.items.length < 2
          },
          on: {
            "change": _vm.setNewIndex
          }
        }, [_c('v-nodes', {
          attrs: {
            "vnodes": _vm.$refs['data-table'].genItems(props.items, props)
          }
        })], 1) : _vm._e()];
      }
    }, _vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header, index) {
      return {
        key: `item.${header.value}`,
        fn: function (_ref) {
          var value = _ref.value,
            item = _ref.item;
          return [_c('span', {
            key: index,
            domProps: {
              "innerHTML": _vm._s(header.formatter.bind(item)(value))
            }
          })];
        }
      };
    }), {
      key: `item.handle`,
      fn: function () {
        return [_c('v-btn', {
          staticStyle: {
            "cursor": "move"
          },
          attrs: {
            "text": "",
            "tile": "",
            "color": "grey darken-1",
            "height": "48",
            "disabled": _vm.items.length < 2
          }
        }, [_c('v-icon', [_vm._v("mdi-drag")])], 1)];
      },
      proxy: true
    }, {
      key: `item.type`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('v-select', _vm._b({
          attrs: {
            "items": _vm.typeItems
          },
          on: {
            "change": function (type) {
              return _vm.onChangeType(type, item);
            }
          },
          model: {
            value: item.type,
            callback: function ($$v) {
              _vm.$set(item, "type", $$v);
            },
            expression: "item.type"
          }
        }, 'v-select', _vm.attrs_input__verticalTable, false))];
      }
    }, {
      key: `item.name`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "disabled": item.type == _vm.PRODUCT_OPTION_CRITERIA_TYPES.COLOR.value,
            "placeholder": "사이즈"
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: item.name,
            callback: function ($$v) {
              _vm.$set(item, "name", $$v);
            },
            expression: "item.name"
          }
        }, 'v-text-field', _vm.attrs_input__verticalTable, false))];
      }
    }, {
      key: `item.values`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [item.type == _vm.PRODUCT_OPTION_CRITERIA_TYPES.COLOR.value ? [_c('options-criteria-color', {
          model: {
            value: item.values,
            callback: function ($$v) {
              _vm.$set(item, "values", $$v);
            },
            expression: "item.values"
          }
        })] : [_c('v-combobox', _vm._b({
          attrs: {
            "multiple": "",
            "item-text": "name",
            "append-icon": "",
            "placeholder": "항목 작성 후 Enter키를 입력해주세요"
          },
          on: {
            "input": function (values) {
              return _vm.mapCriterionValues(item, values);
            }
          },
          scopedSlots: _vm._u([{
            key: "selection",
            fn: function (_ref5) {
              var item = _ref5.item,
                parent = _ref5.parent;
              return [_c('v-chip', {
                attrs: {
                  "outlined": "",
                  "label": "",
                  "close": ""
                },
                on: {
                  "click:close": function ($event) {
                    return parent.selectItem(item);
                  }
                }
              }, [_vm._v(" " + _vm._s(item.name) + " ")])];
            }
          }], null, true),
          model: {
            value: item.values,
            callback: function ($$v) {
              _vm.$set(item, "values", $$v);
            },
            expression: "item.values"
          }
        }, 'v-combobox', _vm.attrs_input__verticalTable, false))]];
      }
    }, {
      key: `item.actions`,
      fn: function (_ref6) {
        var index = _ref6.index;
        return [_c('v-btn', {
          attrs: {
            "text": "",
            "tile": "",
            "height": "48",
            "color": "red"
          },
          on: {
            "click": function ($event) {
              return _vm.pull(index);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-minus")])], 1)];
      }
    }, {
      key: "footer",
      fn: function () {
        return [_c('v-divider'), _c('v-row', {
          attrs: {
            "no-gutters": "",
            "align": "center"
          }
        }, [_c('v-col', [_c('v-btn', {
          attrs: {
            "text": "",
            "tile": "",
            "block": "",
            "height": "58",
            "color": "primary"
          },
          on: {
            "click": _vm.validate
          }
        }, [_c('v-icon', [_vm._v("mdi-chevron-double-down")]), _c('span', [_vm._v(" 목록으로 적용 ")])], 1)], 1), _c('v-divider', {
          attrs: {
            "vertical": ""
          }
        }), _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-btn', {
          attrs: {
            "text": "",
            "tile": "",
            "height": "58",
            "color": "primary"
          },
          on: {
            "click": _vm.push
          }
        }, [_c('v-icon', [_vm._v("mdi-plus")])], 1)], 1)], 1)];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers,
    loading: _vm.loading
  }, false));

}
var staticRenderFns = []

export { render, staticRenderFns }